<form [formGroup]="generateInvoiceForm">
    <h2 class="pb-0" mat-dialog-title>{{dialog_data.is_edit?'Update':'Generate'}} Invoice</h2>

    <mat-dialog-content class="p-3 overflow-hidden">

        <div class="position-sticky top-0">
            <!-- Invoice Details -->
            <div class="fw-bold pb-2">Details</div>
            <div class="row">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-2">
                    <mat-form-field appearance="outline" class="m-1 w-100">
                        <mat-label>Invoice Number</mat-label>
                        <input matInput readonly formControlName="invoice_number" placeholder="Auto-generated" />
                    </mat-form-field>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-2">
                    <mat-checkbox formControlName="is_hide_payment_details" class="m-1">
                        Hide Payment Details
                    </mat-checkbox>
                </div>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-2">
                    <mat-form-field appearance="outline" class="m-1 w-100">
                        <mat-label>Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="invoice_date" required />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-xs-4  col-sm-4 col-md-4 col-lg-4 col-xl-3">
                    <mat-form-field appearance="outline" class="m-1 w-100">
                        <mat-label>Subscription Start Date</mat-label>
                        <input matInput [matDatepicker]="picker_start_date" formControlName="start_date" />
                        @if (generateInvoiceForm.get('start_date')?.value) {
                            <button mat-icon-button matSuffix (click)="generateInvoiceForm.get('start_date')?.setValue(null)">
                                <mat-icon>close</mat-icon>
                            </button>
                        }
                        <mat-datepicker-toggle matSuffix [for]="picker_start_date"></mat-datepicker-toggle>
                        <mat-datepicker #picker_start_date></mat-datepicker>
                        @if (generateInvoiceForm.get('start_date')?.hasError('dateRangeInvalid')) {
                            <mat-error>
                                Start date must be earlier than end date.
                            </mat-error>
                        }
                        @if (generateInvoiceForm.get('start_date')?.hasError('datePairInvalid')) {
                            <mat-error>
                                Both start date and end date are required.
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-3">
                    <mat-form-field appearance="outline" class="m-1 w-100">
                        <mat-label>Subscription End Date</mat-label>
                        <input matInput [matDatepicker]="picker_end_date" formControlName="end_date" />
                        @if (generateInvoiceForm.get('end_date')?.value) {
                            <button mat-icon-button matSuffix (click)="generateInvoiceForm.get('end_date')?.setValue(null)">
                                <mat-icon>close</mat-icon>
                            </button>
                        }
                        <mat-datepicker-toggle matSuffix [for]="picker_end_date"></mat-datepicker-toggle>
                        <mat-datepicker #picker_end_date></mat-datepicker>
                        @if (generateInvoiceForm.get('end_date')?.hasError('dateRangeInvalid')) {
                            <mat-error>
                                End date must be later than start date.
                            </mat-error>
                        }
                        @if (generateInvoiceForm.get('end_date')?.hasError('datePairInvalid')) {
                            <mat-error>
                                Both start date and end date are required.
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
            <hr class="pt-0 pb-0 mt-0 mb-0" />
            <!-- Invoice Items Table -->
            <div class="d-flex justify-content-between align-items-center">
                <div class="mb-2 fw-bold mt-4">Invoice Items</div>
                <div>
                    <button matButton type="button" (click)="addParticular()">
                        <mat-icon>add</mat-icon>Add Items
                    </button>
                </div>
            </div>
        </div>


        <div formArrayName="invoice_line_item" class="overflow-auto" appDynamicHeight [offset]="545" [minHeight]="300">
            <table mat-table [dataSource]="invoiceLineItems.controls" matSort>

                <!-- Item Column -->
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef>Item</th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="p-0">
                        <mat-form-field appearance="outline" class="ms-0 me-0 mt-1 mb-1 w-100 pe-1">
                            <input matInput formControlName="item" required />
                            @if(row.get('item')?.invalid && row.get('item')?.touched){<mat-error>Item is required</mat-error>}
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- HSN Number Column -->
                <ng-container matColumnDef="hsn_number">
                    <th mat-header-cell *matHeaderCellDef>HSN Number</th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="p-0">
                        <mat-form-field appearance="outline" class="ms-0 me-0 mt-1 mb-1 w-100 pe-1">
                            <input matInput formControlName="hsn_number" />
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Rate Column -->
                <ng-container matColumnDef="rate">
                    <th mat-header-cell *matHeaderCellDef>Rate</th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="p-0">
                        <mat-form-field appearance="outline" class="ms-0 me-0 mt-1 mb-1 w-100 pe-1">
                            <input matInput type="number" min="0" formControlName="rate" required
                                (change)="updateTotal(i)" />
                            @if(row.get('rate')?.invalid && row.get('rate')?.touched){<mat-error>Rate must be 0 or more</mat-error>}
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Quantity Column -->
                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>Quantity</th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="p-0">
                        <mat-form-field appearance="outline" class="ms-0 me-0 mt-1 mb-1 w-100 pe-1">
                            <input matInput type="number" min="0" formControlName="quantity" required
                                (change)="updateTotal(i)" />
                            @if(row.get('quantity')?.invalid && row.get('quantity')?.touched){<mat-error>Quantity must be 0 or more</mat-error>}
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Total Column -->
                <ng-container matColumnDef="total_amount">
                    <th mat-header-cell *matHeaderCellDef>Total</th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="p-0">
                        <mat-form-field appearance="outline" class="ms-0 me-1 mt-1 mb-1 w-100">
                            <input matInput type="number" formControlName="total_amount" [readonly]="true" />
                        </mat-form-field>
                        <!-- | number:'1.2-2' -->
                    </td>

                    <td mat-footer-cell *matFooterCellDef>
                        <!-- Example: show total sum or label -->
                        Total Sum
                    </td>

                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <button mat-icon-button (click)="removeParticular(i)" aria-label="Remove Particular">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="position-sticky top-0 z-index-500"></tr>
                <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns" [formGroupName]="i"></tr>
            </table>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="d-flex justify-content-between align-items-center w-100">
            <div>
                <mat-form-field appearance="outline" class="m-0 me-1">
                    <mat-label>Discount</mat-label>
                    <input matInput formControlName="discount_amount" placeholder="Discount" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="m-0 me-1">
                    <mat-label>Sub Total</mat-label>
                    <input matInput formControlName="sub_total" placeholder="Sub Total" />
                </mat-form-field>
                <span class="fs-3 fw-light">&nbsp;|&nbsp;&nbsp;</span>
                <mat-form-field appearance="outline" class="m-0 me-1">
                    <mat-label>{{currentInvoice.tax_1_name}}</mat-label>
                    <div class="d-inline-flex"><input matInput formControlName="tax_1" [placeholder]="currentInvoice.tax_1_name" min="0" max="100" />%</div>
                    @if(generateInvoiceForm.get('tax_1')?.hasError('taxPercentSumInvalid')){<mat-error>Combined tax should not exceed 100.</mat-error>}
                    @if(generateInvoiceForm.get('tax_1')?.hasError('min')){<mat-error>Min value must be 0.</mat-error>}
                    @if(generateInvoiceForm.get('tax_1')?.hasError('max')){<mat-error>Max value must be 100.</mat-error>}
                </mat-form-field>
                <mat-form-field appearance="outline" class="m-0 me-1">
                    <mat-label>{{currentInvoice.tax_2_name}}</mat-label>
                    <div class="d-inline-flex"><input matInput formControlName="tax_2" [placeholder]="currentInvoice.tax_2_name" min="0" max="100" />%</div>
                    @if(generateInvoiceForm.get('tax_2')?.hasError('taxPercentSumInvalid')){<mat-error>Combined tax should not exceed 100.</mat-error>}
                    @if(generateInvoiceForm.get('tax_2')?.hasError('min')){<mat-error>Min value must be 0.</mat-error>}
                    @if(generateInvoiceForm.get('tax_2')?.hasError('max')){<mat-error>Max value must be 100.</mat-error>}
                </mat-form-field>
                <span class="fs-3 fw-light">&nbsp;|&nbsp;&nbsp;</span>
                <mat-form-field appearance="outline" class="m-0 me-1">
                    <mat-label>Grand Total</mat-label>
                    <input matInput formControlName="grand_total" placeholder="Grand Total" [readonly]="true"  />
                </mat-form-field>
            </div>
            <div>
                <button matButton (click)="onClose()"><mat-icon>close</mat-icon>Cancel</button>
                <button matButton [disabled]="commonService.showSpinner" (click)="onSave()"><mat-icon>save</mat-icon>Save</button>
            </div>
        </div>
    </mat-dialog-actions>
</form>